import { FormEvent, useEffect, useState } from "react"
import { AnunciosI } from "../../models/home"
import { getAnuncios, updateAnuncios } from "../../services/anuncios"

const useAnuncios = () => {

    const [formData, setFormData] = useState<AnunciosI>([])
    const [isLoading, setIsLoading] = useState(false)
    const [anunciosEliminados, setAnunciosEliminados] = useState<string[]>([])
    const [isSubmitting, setIsSubmitting] = useState(false)

    const fetchAnuncios = async () => {
        try {
            setIsLoading(true)
            const anuncios = await getAnuncios()
            setFormData(anuncios || [])
        } catch (e) {
            console.error("Error fetching anuncios: ", e)
        } finally {
            setIsLoading(false)
        }
    }

    const onSubmitForm = async (e: FormEvent) => {

        e.preventDefault()

        try {
            setIsSubmitting(true)

            const data = new FormData();

            formData.forEach((anuncio, index) => {
                data.append(`anuncios[${index}][tipo]`, anuncio.tipo || '');
                data.append(`anuncios[${index}][orden]`, String(anuncio.orden || index));

                if (anuncio.id) {
                    data.append(`anuncios[${index}][id]`, anuncio.id);
                }

                if (anuncio.url) {
                    data.append(`anuncios[${index}][url]`, anuncio.url);
                }

                if (anuncio.media) {
                    if (anuncio.media instanceof File) {
                        data.append(`anuncios_media_${index}`, anuncio.media);
                    }
                }
            });

            data.append('anunciosEliminados', JSON.stringify(anunciosEliminados));

            console.log('FormData contenido:', Object.fromEntries(data.entries()));

            await updateAnuncios({
                data: data,
            })

            alert("Anuncios actualizados")
            setIsSubmitting(false)
            setAnunciosEliminados([])
            fetchAnuncios()
        } catch (e) {
            alert("Ocurrió un error")
            console.error("Error ", e)
            setIsSubmitting(false)
        }

    }


    const removeAnuncio = (index: number) => {
        const anuncioEliminado = formData[index];
        if (anuncioEliminado?.id) {
            setAnunciosEliminados(prev => [...prev, anuncioEliminado.id!]);
        }

        setFormData(prev => {
            const updatedAnuncios = [...prev];
            updatedAnuncios.splice(index, 1);
            // Reasignar órdenes
            return updatedAnuncios.map((anuncio, i) => ({
                ...anuncio,
                orden: i
            }));
        });
    }

    useEffect(() => {
        fetchAnuncios()
    }, [])

    return {
        formData,
        setFormData,
        onSubmitForm,
        removeAnuncio,
        isLoading,
        isSubmitting,
        fetchAnuncios,
    }

}

export default useAnuncios
